export default __webpack_public_path__ + "static/media/player-wild-rift-avatar.893749a0.png";